import { render, staticRenderFns } from "./FormMarketing.vue?vue&type=template&id=7275090d&scoped=true&"
import script from "./FormMarketing.vue?vue&type=script&lang=js&"
export * from "./FormMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7275090d",
  null
  
)

export default component.exports